import { action, observable, computed } from "mobx";
import { post } from "../../services/ajax-calls.service";
class MedicalMarketCheckStore {
  @observable payers = [];
  @observable extended_payers = [];
  @observable delete_contract_dropdown = [];
  @observable deleted_extended_contract_dropdown = []
  @observable referenceBased = [];
  @observable delete_dropdown = false;
  @observable url = "/api/v1/medicalActions/marketcheck";
  @observable payor_index;
  @observable reportError="";
  @observable excluded_claims_count=0;
  @observable excluded_claims=[];
  @observable use_overall_medicare_rate_for_reference_based = true

  @computed get totalCostSumCurrent() {
    return this.totalCostSum();
  }

  @computed get tiles() {
    return parseInt(this.excluded_claims_count / 100) > 0 ? parseInt(this.excluded_claims_count / 100) + 1 : 0;
  }

  @action getExcludedClaimsCount = async data => {
    try {
      this.excluded_claims_count=0;
      let response = await post(
        `${this.url}/getExcludedClaimsCount`,
        data
      );
      this.excluded_claims_count = response?.data[0]?.excluded_claim_count ?? 0;
    } catch (err) {
      console.log(err);
    }
  }

  @action get_excluded_claims = async data => {
    this.excluded_claims = [];
    try {
      let response = await post(
        `${this.url}/get_excluded_claims`,
        data
      );
      this.excluded_claims = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action toggle_reference_based_medicare_rate =() => {
    this.use_overall_medicare_rate_for_reference_based = !this.use_overall_medicare_rate_for_reference_based
  }

  @action filter_groups_medical_market_check = async data => {
    try {
      let response = await post(
        `${this.url}/filter_groups_medical_market_check`,
        data
      );

      return response.data
    } catch (err) {
      console.log(err);
    }
  }
  @action getDateRange = async data => {
    try {
      let response = await post(
        `${this.url}/getDateRange`,
        data
      );

      return response.data
    } catch (err) {
      console.log(err);
    }
  }

  @action getMedicalMarketCheck = async (data, override=true) => {
    if(override) {
      this.payers = [];
      this.referenceBased = [];
    }
    this.extended_payers = []

    try {
      let response = await post(`${this.url}/getMedicalPayers`, data);
      if(override) {
        this.payers = response.data;
      }
      else {
        this.extended_payers = response.data;

      }
      this.referenceBased = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };

  setMedicareRate = (category, value) => {
    let reference_based_copy = JSON.parse(JSON.stringify(this.referenceBased));
    reference_based_copy.categories.filter(c => c.category == category)[0].medicare_rate = value;
    this.referenceBased = reference_based_copy
  }
  onchangeInput = ( index, range_value) => {
    this.referenceBased.categories = this.referenceBased.categories.map((category) => {
      return category.map((item, itemIndex) => {
        if (itemIndex === index) {
          return {
            ...item,
            medicare_price: Number(item.original_medicare_price) * (range_value/100),
          };

        } else {
          return item;
        }
      });
    });
  };

  @action calculate_average_medicare = (index) => {
    const payer = JSON.parse(JSON.stringify(this[this.payor_key][index]));
    const total_sum = payer.categories.reduce((a,b) => Number(a) + (Number(b[index == 0 ? "total_cost" : "adjusted_rate_high" ])), 0);
    const total_medicare = payer.categories.reduce((a,b) => Number(a) + (Number(b.medicare_price)), 0);
    return (total_sum/total_medicare) * 100
  }

  @action calculate_average_match_rate = (index,return_totals_only=false) => {
    if(this[this.payor_key][index] == null) {
      return 0
    }
    const payer = JSON.parse(JSON.stringify(this[this.payor_key][index]));

    const total_overall = payer.categories.reduce((a,b) => Number(a) + (Number(b["overall_count"])), 0);
    const total_unmatched = payer.categories.reduce((a,b) => Number(a) + (Number(b["unmatched_count"])), 0);
    if(return_totals_only) {
      return {
        total_unmatched,
        total_overall}
    }
    return ((total_overall - total_unmatched)/total_overall) * 100
  }

  @action totalCostSum = () => {
    const data = JSON.parse(JSON.stringify(this.payers[0]));
    let sum = 0;
    data.categories.map((i) => {

        const totalCost = parseFloat(i.total_cost);
        if (!isNaN(totalCost)) {
          sum += totalCost;
        }

    });
    return sum;
  };

  @action deleteContract = (index) => {
    if (localStorage.getItem(`${this.deleted_payor_key}`)) {
      let tempArr = [];
      tempArr = JSON.parse(
        localStorage.getItem(`${this.deleted_payor_key}`)
      );
      tempArr.push(this[this.payor_key][index]);
      localStorage.setItem(
        `${this.deleted_payor_key}`,
        JSON.stringify(tempArr)
      );
      this[this.deleted_extended_payor_var] = tempArr;
      this.payers[index] = null;
      return;
    }
    this[this.deleted_extended_payor_var].push(this[this.payor_key][index]);
    localStorage.setItem(
      `${this.deleted_payor_key}`,
      JSON.stringify([this[this.payor_key][index]])
    );
    this[this.payor_key][index] = null;
  };

  @action createDeleteContract = (data) => {
    localStorage.setItem(
      `${this.deleted_payor_key}`,
      JSON.stringify(data)
    );
  };

  @action DeleteContractAdd = (index) => {
    let tempArr = [];
    this[this.deleted_extended_payor_var] = [];
    tempArr = JSON.parse(
      localStorage.getItem(`${this.deleted_payor_key}`)
    );
    this[this.payor_key].push(tempArr[index]);
    let TempArr_2 = [];
    for (var a = 0; a < tempArr.length; a++) {
      if (index != a) {
        TempArr_2.push(tempArr[a]);
      }
    }
    localStorage.setItem(
      `${this.deleted_payor_key}`,
      JSON.stringify(TempArr_2)
    );
    this[this.deleted_extended_payor_var] = TempArr_2;
    if (TempArr_2.length == 0) {
      this.delete_dropdown = false;
    }
  };
  @computed get payor_key() {
    return this.payor_index != null ? "extended_payers": "payers"
  }
  @computed get deleted_payor_key() {
    return this.payor_index != null ? "deleted_extended_contract_by_market_check_medical": "deleted_contract_by_market_check_medical"
  }
  @computed get deleted_extended_payor_var () {
    return this.payor_index != null ? "deleted_extended_contract_dropdown": "delete_contract_dropdown"
  }
  @action removeItemFromPayers = async (index) => {

    if (index >= 0 && index < this[this.payor_key].length) {
      this[this.payor_key].splice(index, 1);
    }
  };

  @action duplicateItemInPayers = async (index) => {

    if (index >= 0 && index < this[this.payor_key].length) {

      const itemToDuplicate = this[this.payor_key][index];
      this[this.payor_key].splice(index + 1, 0, { ...itemToDuplicate });
    }
  };

  @action generateExcludedClaimsCsv = async data => {
    this.reportError = "";
    try {
      let response = await post(
        `${this.url}/generateExcludedClaimsCsv`,
        data
      );

      return true
    } catch (err) {
      this.reportError = err.response.data
      console.log(err);
    }
  };

  @action generateXlsxReport = async data => {
    this.reportError = "";
    try {
      let response = await post(
        `${this.url}/generateXlsxReport`,
        data
      );

      return true;
    } catch (err) {
      this.reportError = err.response.data
      console.log(err);
    }
  };



  viewPayor = async (index) => {
    this.payor_index = index
    const run_id = this.payers[index].run_id;
    await this.getMedicalMarketCheck({ run_id }, false);
  }

  goBack = () => {
    localStorage.removeItem(`${this.deleted_payor_key}`);
    this.deleted_extended_contract_dropdown = []
    this.payor_index = null;
  }
}

export default MedicalMarketCheckStore;
